import { getFormattedDate } from '@lmt/unicorn-shared/app/components/patients/common';
import React, { FC, useMemo } from 'react';
import { DragObject } from '../../devextreme/common';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { patientTabIcon } from '@lmt/unicorn-shared/app/helpers/cached-images';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { useTabs } from '@lmt/unicorn-shared/app/features/navigation/operations';
import { pages } from '@lmt/unicorn-shared/app/constants/sharedRoutes';

import styles from './PatientItem.module.scss';

interface Props {
  patientId: number;
  patientName: string;
  subtenantCode: string;
  dateOfBirth: Date;
}

export const PatientItem: FC<Props> = (props) => {
  const tabs = useTabs();
  const item: DragObject = useMemo(() => {
    const tabWithPatient: DragObject = {
      title: props.patientName,
      icon: patientTabIcon,
      type: 'patient',
      viewType: 'patient-in-calendar-list',
      patientId: props.patientId,
    };

    return tabWithPatient;
  }, []);

  const sortable = useMemo(
    () => ({ id: `${tabs.tabId}_${props.patientId}`, data: item }),
    [item],
  );
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable(sortable);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ?? undefined,
  };
  const sortableProps = {
    ref: setNodeRef,
    style,
    ...attributes,
    ...listeners,
  };

  return (
    <div
      {...sortableProps}
      className={styles.container}
      data-test-id="patient-list-item"
    >
      <div className={styles.row}>
        <div
          color={ButtonColor.Primary}
          onClick={() => {
            tabs.openTab(
              pages.patientProfile.link({ patientId: props.patientId }),
            );
          }}
          className={styles.patientName}
          title={props.patientName}
        >
          {props.patientName}
        </div>
        <div className={styles.code}>{props.subtenantCode}</div>
      </div>
      <div className={styles.date}>{getFormattedDate(props.dateOfBirth)}</div>
    </div>
  );
};
